import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import ScoringRubric from 'types/api/ScoringRubric';

import './ReviewRatingBulb.scss';

export interface ReviewRatingBulbProps {
  scoringRubrics?: ScoringRubric[] | null;
  score?: number | undefined | null;
  variant?: 'bulb' | 'with-label';
}

type Colors = 'Red' | 'Yellow' | 'Green' | 'Grey';

const labelMap = {
  Green: 'rating.inCompliance',
  Yellow: 'rating.notInCompliance',
  Red: 'rating.notApplicable',
  Grey: 'rating.notReviewed',
} as const;

export interface RawReviewRatingBulbProps {
  variant: 'bulb' | 'with-label';
  color: Colors;
}

const RawBulb = ({ variant, color }: RawReviewRatingBulbProps) => {
  const { t } = useTranslation();

  return (
    <div className="enkrateia-review-rating-bulb">
      <div className={color}></div>
      <div className={variant}>{t(labelMap[color])}</div>
    </div>
  );
};

const ReviewRatingBulb = ({ scoringRubrics, score, variant = 'bulb' }: ReviewRatingBulbProps) => {
  const color = useMemo((): Colors => {
    if (!scoringRubrics || scoringRubrics.length === 0 || score === undefined || score === null) {
      return 'Grey';
    }

    return (
      [...scoringRubrics]
        .sort((a, b) => a.low_score - b.low_score)
        .find((r) => r.low_score <= score && score <= r.high_score)?.highlight_color ?? 'Grey'
    );
  }, [scoringRubrics, score]);

  return <RawBulb variant={variant} color={color} />;
};

ReviewRatingBulb.RawBulb = RawBulb;

export default ReviewRatingBulb;
